export function sbPopup(text, style, timer, selector) {
    // Create the popup
    let popup = document.getElementById('popup');

    if (!popup) {
        popup = document.createElement('div');
        popup.setAttribute('id', 'popup');
        popup.innerHTML =
            '<div class="popup-icon"></div>' +
            '<span></span>';

        document.body.appendChild(popup);
    }


    // Set the correct style
    style = style || 'info';


    // Initialize
    let timout = 0;
    if (popup.classList.contains('active')) {
        popup.classList.remove('active');
        timout = 600;
    }

    setTimeout(() => {
        popup.querySelector('span').innerHTML = text;
        popup.className = '';
        popup.classList.add('active');
        popup.classList.add(style);
    }, timout);


    // timer function to automatically remove the popup
    if (timer) {
        setTimeout(() => {
            popup.classList.remove('active');
        }, timer);
    }

    // A selector to scroll to when the popup is activated
    if (selector) {
        if (window.innerWidth < 950) {
            scrollToSelector(selector, -100);
        } else {
            scrollToSelector(selector, -300);
        }
    }


    // Remove the popup when clicking a form element
    [].slice.call(document.querySelectorAll('#popup, .form-info, .select, select, input, textarea, .form-row-checkbox label, .form-row-radio, label, .toggle-picker, .typ')).forEach(function(destroyPopup) {
        destroyPopup.addEventListener('click', () => {
            popup.classList.remove('active');
        });
    });
}


